/**
 * OpenAPI definition
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface OrderDTO { 
    property?: string;
    direction?: OrderDTO.DirectionEnum;
}
export namespace OrderDTO {
    export const DirectionEnum = {
        Asc: 'ASC',
        Desc: 'DESC'
    } as const;
    export type DirectionEnum = typeof DirectionEnum[keyof typeof DirectionEnum];
}


